import { CloudUploadIcon, FileXIcon } from 'lucide-react'
import type { DropzoneRootProps } from 'react-dropzone'

import { cn } from '@/utils'

interface PageDropOverlayProps {
  rootProps: DropzoneRootProps
  hint: string
  rejectMessage?: string
}

export const PageDropOverlay = ({
  rootProps,
  hint,
  rejectMessage,
}: PageDropOverlayProps) => {
  const Icon = rejectMessage ? FileXIcon : CloudUploadIcon

  return (
    <div
      {...rootProps}
      className={cn(
        'fixed inset-0 z-50 flex items-center justify-center backdrop-blur-[1px]',
        rejectMessage ? 'bg-red-600/10' : 'bg-brand/10',
      )}
    >
      <div
        className={cn(
          'flex flex-col items-center gap-2 rounded-lg border-2 border-dashed bg-white px-10 py-8 text-center shadow-lg',
          rejectMessage ? 'border-red-600' : 'border-brand',
        )}
      >
        <Icon
          className={cn(
            'size-10',
            rejectMessage ? 'text-red-600' : 'text-brand',
          )}
        />
        {rejectMessage ? (
          <p className="font-medium text-red-600" role="alert">
            {rejectMessage}
          </p>
        ) : (
          <p className="font-medium">Drop files to add them</p>
        )}
        {hint && <p className="text-ink-subtle text-xs">{hint}</p>}
      </div>
    </div>
  )
}
